export default __webpack_public_path__ + "static/media/fajita_vegetable.367aa2d3.wav";